import React, { useEffect, useState } from 'react';
import Button from '@amzn/meridian/button';
import { Image } from 'react-bootstrap';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import UserProfile from '../../../../../global/user-profile';
import spinner from '../../../../../static/spinner.gif';

export const AbMetricsLookupViewer = ({ nodeData, onConfirm, onCancel: onExit, isConfirmed, isVerified }) => {
  const [fullName, setFullName] = useState(null);
  const [confirmButton, setConfirmButton] = useState(<>Confirm</>);

  useEffect(() => {
    UserProfile.getUserInformation().then(info => {
      setFullName(info.fullName);
    });
  }, [nodeData]);

  const onClick = () => {
    setConfirmButton(<Image src={spinner} style={{ height: '60%' }} />);
    onConfirm();
  };

  const popUpMessage = isConfirmed ? (
    isVerified ? (
      <div>
        <p>
          AB test metrics pulling task successfully initiated - this might take a few minutes. Results will be emailed
          to <b>{fullName}</b> shortly.
        </p>
      </div>
    ) : (
      <div>
        <p>
          Please verify your email first in order to receive metrics collection status updates. An email from{' '}
          <b>no-reply-aws@amazon.com</b> with verification link will be sent to: <b>{fullName}</b> shortly.
        </p>
      </div>
    )
  ) : (
    <div>
      <p>Are you sure to pull all metrics for this A/B test?</p>
    </div>
  );

  const footerButtons = isConfirmed ? (
    <Button type="primary" onClick={onExit}>
      Okay
    </Button>
  ) : (
    <>
      <Button type="secondary" onClick={onExit}>
        Cancel
      </Button>
      <Button type="primary" onClick={onClick}>
        {confirmButton}
      </Button>
    </>
  );

  const AB_METRICS_LOOKUP_HEADER = `A/B Test Metrics of Experiment ${nodeData.parameters.id}`;
  return (
    <Modal open title={AB_METRICS_LOOKUP_HEADER} width="400px">
      {popUpMessage}
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          {footerButtons}
        </Row>
      </ModalFooter>
    </Modal>
  );
};
